document.addEventListener(
	'DOMContentLoaded',
	function () {
		const body = document.querySelector('.wp-site-blocks');

		let fontSize = parseInt(localStorage.getItem('font-size')) || 16;
		const MIN_FONT_SIZE = 16;
		const MAX_FONT_SIZE = 26;
		const FONT_SIZE_STEP = 4;

		const updateFontSize = (newSize) => {
			const clampedSize = Math.max(MIN_FONT_SIZE, Math.min(newSize, MAX_FONT_SIZE));
			body.style.fontSize = `${clampedSize}px`;
			localStorage.setItem('font-size', clampedSize);
		};

		const addFontSizeEventListeners = (selector, step) => {
			document.querySelectorAll(selector).forEach((element) => {
				element.addEventListener('click', () => {
					updateFontSize((fontSize += step));
				});
			});
		};

		addFontSizeEventListeners('.font-down', -FONT_SIZE_STEP);
		addFontSizeEventListeners('.font-up', FONT_SIZE_STEP);

		updateFontSize(fontSize);
	},
	false,
);
